export const SanitizedUrlKeys = ["action"];
